import { render } from "./CarLoader.vue?vue&type=template&id=8bcb8ba6&scoped=true"
import script from "./CarLoader.vue?vue&type=script&lang=js"
export * from "./CarLoader.vue?vue&type=script&lang=js"

import "./CarLoader.vue?vue&type=style&index=0&id=8bcb8ba6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bcb8ba6"]])

export default __exports__